"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Processor_1 = __importDefault(require("./Processor"));
var base_64_1 = __importDefault(require("base-64"));
var rest = new Processor_1.default();
function httpGet(url, headers) {
    if (headers === void 0) { headers = {}; }
    return doApi(doFetch(url, {
        method: "get",
        headers: buildHeaders("GET", url, headers),
    }), url, "GET");
}
exports.httpGet = httpGet;
function httpPost(url, data, headers) {
    if (headers === void 0) { headers = {}; }
    if (data) {
        // tslint:disable-next-line:no-empty
        if (data.constructor === ArrayBuffer) {
        }
        else if (typeof data === "object") {
            data = JSON.stringify(data);
        }
    }
    return httpPostRaw(url, data, headers);
}
exports.httpPost = httpPost;
function httpDelete(url, data, headers) {
    if (headers === void 0) { headers = {}; }
    if (data) {
        // tslint:disable-next-line:no-empty
        if (data.constructor === ArrayBuffer) {
        }
        else if (typeof data === "object") {
            data = JSON.stringify(data);
        }
    }
    return httpDeleteRaw(url, data, headers);
}
exports.httpDelete = httpDelete;
function httpPut(url, data, headers) {
    if (headers === void 0) { headers = {}; }
    if (data) {
        // tslint:disable-next-line:no-empty
        if (data.constructor === ArrayBuffer) {
        }
        else if (typeof data === "object") {
            data = JSON.stringify(data);
        }
    }
    return doApi(doFetch(url, {
        method: "put",
        headers: buildHeaders("PUT", url, headers),
        body: data,
    }), url, "PUT");
}
exports.httpPut = httpPut;
function httpPostRaw(url, data, headers) {
    if (headers === void 0) { headers = {}; }
    return doApi(doFetch(url, {
        method: "post",
        headers: buildHeaders("POST", url, headers),
        body: data,
    }), url, "POST");
}
exports.httpPostRaw = httpPostRaw;
function httpDeleteRaw(url, data, headers) {
    if (headers === void 0) { headers = {}; }
    return doApi(doFetch(url, {
        method: "delete",
        headers: buildHeaders("DELETE", url, headers),
        body: data,
    }), url, "DELETE");
}
exports.httpDeleteRaw = httpDeleteRaw;
function doFetch(input, init) {
    var opt = init ? __assign({}, init) : {};
    var url = input;
    if (typeof input != "string") {
        url = input.url;
    }
    for (var _i = 0, _a = rest.fetchOptionProcessor; _i < _a.length; _i++) {
        var processor = _a[_i];
        opt = processor(init === null || init === void 0 ? void 0 : init.method, url, opt);
    }
    return fetch(input, opt);
}
function buildHeaders(httpMethod, url, extra) {
    var headers = {};
    for (var _i = 0, _a = rest.headerProcessor; _i < _a.length; _i++) {
        var processor = _a[_i];
        headers = processor(httpMethod, url, headers, extra);
    }
    return new Headers(__assign(__assign({}, headers), extra));
}
function doApi(promise, url, httpMethod) {
    return promise.then(function (response) {
        handleHttpResponse(response, url, httpMethod);
        return response.json();
    }).then(function (jsonResponse) {
        for (var _i = 0, _a = rest.jsonProcessor; _i < _a.length; _i++) {
            var processor = _a[_i];
            processor(httpMethod, url, jsonResponse);
        }
        return jsonResponse;
    });
}
function handleHttpResponse(response, url, httpMethod) {
    for (var _i = 0, _a = rest.responseProcessor; _i < _a.length; _i++) {
        var processor = _a[_i];
        processor(httpMethod, url, response);
    }
}
function base64ToArrayBuffer(base64) {
    var binaryString = base_64_1.default.decode(base64);
    var len = binaryString.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
exports.base64ToArrayBuffer = base64ToArrayBuffer;
exports.default = rest;
